import React, { PureComponent, Fragment } from 'react';
import { shape, string, func, bool } from 'prop-types';
import compose from 'lodash/flowRight';
import { productShape } from 'shapes';
import classnames from 'classnames';
import { withBaseUrls, withAddToCart, withEnvironmentData } from 'connectors';

class ProductCardCTA extends PureComponent {
    static propTypes = {
        product: productShape.isRequired,
        baseUrls: shape({
            main: string,
        }).isRequired,
        addToCart: func.isRequired,
        platform: shape({
            IS_PLATFORM_DE: bool,
        }).isRequired,
    };

    handleClick = evt => {
        if (this.props.product.models_count > 1) return;

        evt.stopPropagation();
        evt.preventDefault();

        if (this.props.addToCart) {
            this.props.addToCart(evt);
        }
    };

    render() {
        const { product, baseUrls, platform } = this.props;

        const buttonClasses = classnames(
            'product-card-cta',
            'button',
            'button--primary',
            'button--small',
            {
                'js-add-to-basket':
                    !product.models_count || product.models_count === 1,
            },
        );

        return (
            <Fragment>
                <button
                    type="button"
                    className={buttonClasses}
                    data-event="add_to_cart"
                    data-url={`${baseUrls.main}/cart/product/${product.objectID}/update`}
                    data-quantity={product.minQuantity || 1}
                    data-error="En rupture de stock"
                    data-product-id={product.objectID}
                    data-name={product.title}
                    data-button="addToBasket"
                    data-article-id={product.article_id}
                    data-category-id={product['categories.last_id']}
                    data-category={product['categories.last']}
                    data-has-x-payment={
                        product.has_3x_payment ? 'true' : 'false'
                    }
                    data-model-id={product.model_id}
                    data-price={product.price}
                    data-seller-id={product.seller_id}
                    data-seller-name={product.seller_name}
                    data-product-sku={product.sku}
                    onClick={this.handleClick}
                >
                    <i className="product-card-cta__icon icon icon__cart icons_button" />
                    <span className="product-card-cta__label">
                        {product.models_count > 1
                            ? `Voir les ${product.models_count} modèles`
                            : 'Ajouter au panier'}
                    </span>
                </button>

                {platform.IS_PLATFORM_DE && (
                    <span className="product-card-cta__legal">
                        Inkl. MwSt., zzgl. Versand
                    </span>
                )}
            </Fragment>
        );
    }
}

export default compose(
    withBaseUrls,
    withAddToCart,
    withEnvironmentData,
)(ProductCardCTA);
